import { render, staticRenderFns } from "./SelectedGCS.vue?vue&type=template&id=0cf3f597&scoped=true&"
import script from "./SelectedGCS.vue?vue&type=script&lang=ts&"
export * from "./SelectedGCS.vue?vue&type=script&lang=ts&"
import style0 from "./SelectedGCS.vue?vue&type=style&index=0&id=0cf3f597&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf3f597",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("c:\\vNextBuildV3\\29\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0cf3f597', component.options)
    } else {
      api.reload('0cf3f597', component.options)
    }
    module.hot.accept("./SelectedGCS.vue?vue&type=template&id=0cf3f597&scoped=true&", function () {
      api.rerender('0cf3f597', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "VueApp/views/CallCenter/SelectedGCS.vue"
export default component.exports